import FormAssetUploadField from "../assetUploadField";
import { AssetInputMode, AssetUploadType, CustomRendererType } from "../../core/assetUpload/types";
import Button from "../../../components/button";
import DefaultAssetUIRenderer from "../../core/assetUpload/defaultAssetUIRenderer";
import { DEFAULT_ASSET_CONFIG } from "../../core/assetUpload/constants";
import { getAssetUploadRecommendedCopy } from "../../core/assetUpload/util";
import { useCopies } from "../../../hooks/useCopies";
import { FormMultiImageUploadFieldType } from "./type";
import PreviewMultiImageSlider from "../../../components/imageSlider";
import { useFormikContext } from "formik";
import { AnyObject } from "../../../../global";
import { AssetType } from "../../../enums/AssetType";
import Variant from "shared/enums/Variant";
import Icon from "assets/icons";
import ImageAspectRatioWarning from "shared/form/core/aspectRatioWarning";
import FieldValueCount from "shared/components/fieldValueCount";

function FormMultiImageUploadField({
  assetConfig = DEFAULT_ASSET_CONFIG,
  assetType = AssetType.USER_INPUT,
  ...props
}: FormMultiImageUploadFieldType) {
  const { touched } = useFormikContext<AnyObject>();
  return (
    <FormAssetUploadField
      customRenderer={customProps => {
        return <MultiImageUploadCustomRenderer {...customProps} maxAssetCount={props.max} />;
      }}
      previewRenderer={customPreviewProps => {
        return (
          <div className="multiImage--slider">
            <PreviewMultiImageSlider
              {...customPreviewProps}
              startIndex={touched?.[props.name] ? customPreviewProps.uploadedAssets.length - 1 : 0}
            />
            {customPreviewProps.uploadedAssets?.filter(asset => asset.incorrectAspectRatio).length > 0 && (
              <ImageAspectRatioWarning />
            )}
            <FieldValueCount
              className="defaultAsset--count"
              maxCount={props.max}
              value={customPreviewProps.uploadedAssets.length}
            />
          </div>
        );
      }}
      assetUploadType={AssetUploadType.IMAGE}
      assetType={assetType}
      registrationId={props.registrationId}
      registrationParticipantId={props.registrationParticipantId}
      label={props.label}
      required={props.required}
      additionalLabel={props.additionalLabel}
      name={props.name}
      disabled={props.disabled}
      assetInputMode={AssetInputMode.MULTI}
      fullWidth={props.fullWidth}
      assetConfig={assetConfig}
      infoLabel={props.infoLabel}
      validate={props.validate}
    />
  );
}

export default FormMultiImageUploadField;

function MultiImageUploadCustomRenderer(props: CustomRendererType & { maxAssetCount?: number }) {
  const copies = useCopies();
  if (props.uploadedAssets?.length > 0) {
    return (
      <div className="multiImage--upload">
        <div className="multiImage--upload_note">
          {getAssetUploadRecommendedCopy({ copies, config: props.assetConfig })}
        </div>
        <input {...props.dropzoneState?.getInputProps()} />
        <Button
          icon={<Icon.AddImage />}
          label={copies.get("add.more")}
          variant={Variant.LINK}
          className="multiImage--upload_add"
          onClick={props.dropzoneState?.open}
          disabled={props.disabled || props.uploadedAssets?.length === props.maxAssetCount}
        />
      </div>
    );
  } else {
    return <DefaultAssetUIRenderer {...props} />;
  }
}
